import React from 'react'
import PropTypes from 'prop-types'
import { Form, FormGroup, FormControl } from 'react-bootstrap'

class NavSearch extends React.Component {
  constructor(...args) {
    super(...args)
    this.state = {
      value: ''
    }
  }

  onChange = (e) => this.setState({ value: e.target.value })

  handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      this.props.onSearch(this.state.value)
    }
  }

  render() {
    return (
      <li>
        <Form className='navbar-form'>
          <FormGroup controlId='search'>
            <FormControl value={this.state.value || ''}
              placeholder='Search...'
              onKeyPress={this.handleKeyPress}
              onChange={this.onChange}
              autoComplete='off'
              style={{width: 140}} />
          </FormGroup>
        </Form>
      </li>
    )
  }
}

NavSearch.propTypes = {
  onSearch: () => {},
}

NavSearch.propTypes = {
  onSearch: PropTypes.func,
}

export default NavSearch



// WEBPACK FOOTER //
// ./src/components/nav/NavSearch.js